// extracted by mini-css-extract-plugin
export default {"qpayContain":"style_qpayContain__PTMtN","errorText":"style_errorText__GtXNy"};